import { IBrannkoseptRapport } from "../reportSchemas/brannkonseptSchema.js";

export const BRANNKONSEPT_INIT_DATA: IBrannkoseptRapport = {
  infoOmOppdraget: {
    oppdragsnavn: "",
    oppdragsgiver: "",
    oppdragsnummer: "",
  },
  optionSections: {
    BKL: {
      title: "Brannklasse",
      options: {
        BKL1: {
          isSelected: false,
          name: "BKL 1",
        },
        BKL2: {
          isSelected: false,
          name: "BKL 2",
        },
        BKL3: {
          isSelected: false,
          name: "BKL 3",
        },
      },
    },
    ansvarsforhold: {
      title: "Ansvarsforhold i byggesak og tilleggskrav fra tiltakshaver",
      options: {
        Tiltaksklasse3: {
          isSelected: false,
          name: "Tiltaksklasse 3",
        },
        Tiltaksklasse2: {
          isSelected: false,
          name: "Tiltaksklasse 2",
        },
        Tiltaksklasse1: {
          isSelected: false,
          name: "Tiltaksklasse 1",
        },
        IkkeSoknadspliktig: {
          isSelected: false,
          name: "Ikke søknadspliktig",
        },
        Tilleggskrav: {
          isSelected: false,
          name: "Tilleggskrav fra tiltakshaver",
        },
      },
    },
    dokumentasjonsform: {
      title: "Dokumentasjonsform",
      options: {
        Preakseptert: {
          isSelected: false,
          name: "Preakseptert",
        },
        Blandingslosning: {
          isSelected: false,
          name: "Blandingsløsning (hovedsakelig preakseptert men noen fravik)",
        },
        FullstendigAnalyse: {
          isSelected: false,
          name: "Fullstendig analyse (automatisert mal er uegnet)",
        },
      },
    },
    spesifikkBrannenergi: {
      title: "Spesifikk brannenergi",
      options: {
        BeregnetSpesieltUnder: {
          isSelected: false,
          name: "Beregnet spesielt til å være under 50 MJ/m2",
        },
        NormalBrannenergi: {
          isSelected: false,
          name: "Normal brannenergi 50-400 MJ/m2",
        },
        BeregnetSpesieltOver: {
          isSelected: false,
          name: "Beregnet spesielt til å være over 400 MJ/m2",
        },
      },
    },
    spesielleForhold: {
      title: "Er det spesielle forhold i bygget som må beskrives nærmere?",
      options: {
        Ja: {
          isSelected: false,
          name: "Ja",
        },
        Nei: {
          isSelected: false,
          name: "Nei",
        },
      },
    },
    trapperom: {
      title: "Trapperom",
      instructions: "Hvilke type trapperom skal det være i byggverket?",
      options: {
        Tr1: {
          isSelected: false,
          name: "Tr1",
        },
        Tr2: {
          isSelected: false,
          name: "Tr2",
        },
        Tr3: {
          isSelected: false,
          name: "Tr3",
        },
        Interntrapp: {
          isSelected: false,
          name: "Interntrapp",
        },
        Utvendigtrapp: {
          isSelected: false,
          name: "Utvendig trapp",
        },
      },
    },
    risikoklasse: {
      title: "Risikoklasse",
      options: {
        RKL1: {
          isSelected: false,
          name: "RKL1",
        },
        RKL2: {
          isSelected: false,
          name: "RKL2",
        },
        RKL3: {
          isSelected: false,
          name: "RKL3",
        },
        RKL4: {
          isSelected: false,
          name: "RKL4",
        },
        RKL5: {
          isSelected: false,
          name: "RKL5",
        },
        RKL6: {
          isSelected: false,
          name: "RKL6",
        },
      },
    },
    branntegninger: {
      title: "Branntegninger",
      instructions:
        "Vil det utarbeides og leveres branntegninger samtidig som du leverer notatet?\n" +
        "\n" +
        "Dersom du krysser av ja, vil flere brannkravene kun bli henvist til tegning. " +
        "\n" +
        "Av hensyn til å tydeliggjøre brannkrav, så anbefales løsning der tegninger viser brannkrav.",
      options: {
        Ja: {
          isSelected: false,
          name: "Ja",
        },
        Nei: {
          isSelected: false,
          name: "Nei",
        },
      },
    },
    brannspredningMellomByggverk: {
      title: "Tiltak mot brannspredning mellom byggverk",
      instructions: "Sett kryss for det som gjelder ditt byggverk",
      options: {
        lavtOver8m: {
          isSelected: false,
          name: "Lavt byggverk over 8 m til nabobygg.",
        },
        lavtMindre8m: {
          isSelected: false,
          name: "Lavt byggverk mindre enn 8 m til nabobyg",
        },
        hoytOver8m: {
          isSelected: false,
          name: "Høyt byggverk over 8 m til nabobygg.",
        },
        hoytMindre8m: {
          isSelected: false,
          name: "Høy byggverk mindre enn 8 m til nabobygg",
        },
        sarskiltStorSannsynlighet: {
          isSelected: false,
          name: "Særskilt stor sannsynlighet for brannspredning",
        },
      },
    },
    etasjetall: {
      title: "Etasjetall",
      instructions: "Sett kryss for det som gjelder ditt byggverk",
      options: {
        inntil8: {
          isSelected: false,
          name: "Inntil 8 etasjer høy",
        },
        over8: {
          isSelected: false,
          name: "Over 8 etasjer høyt",
        },
        enKjeller: {
          isSelected: false,
          name: "Én kjelleretasje",
        },
        flereKjeller: {
          isSelected: false,
          name: "Flere kjelleretasjer",
        },
      },
    },
    brannseksjonering: {
      title: "Brannseksjonering",
      instructions: "Skal byggverket brannseksjoneres? Kryss av for det som gjelder.",
      options: {
        nei: {
          isSelected: false,
          name: "Nei",
        },
        jaREI90M: {
          isSelected: false,
          name: "Ja, REI90-M",
        },
        jaREI120M: {
          isSelected: false,
          name: "Ja, REI120-M",
        },
        jaREI180M: {
          isSelected: false,
          name: "Ja, REI180-M",
        },
        jaREI240M: {
          isSelected: false,
          name: "Ja, REI240-M",
        },
        brannseksjoneringsdekke: {
          isSelected: false,
          name: "Brannseksjoneringsdekke - hele eller deler av brannseksjoneringen tas i dekket.",
        },
      },
    },
    roykkontroll: {
      title: "Røykkontroll",
      instructions: "Hvilke type røykkontroll skal du ha i byggverket?",
      options: {
        ja: {
          isSelected: false,
          name: "Ja, bygget utføres med røykkontroll",
        },
        royklukeItrapperom: {
          isSelected: false,
          name: "Røykluke i trapperom",
        },
        roykventilasjonSjakterOgHeis: {
          isSelected: false,
          name: "Røykventilasjon av installasjonssjakter og heissjakter",
        },
        trykksettingAvTrapperom: {
          isSelected: false,
          name: "Trykksetting av trapperom",
        },
      },
    },
    branncelleinndeling: {
      title: "Branncelleinndeling",
      instructions: "Kryss av for hvilke forhold eller løsninger som er aktuelle for ditt byggverk.",
      options: {
        overbyggetRoykventilertgard: {
          isSelected: false,
          name: "Overbygget og røykventilert gård/gate/atrium eller lignende",
        },
        oppforetTakLoft: {
          isSelected: false,
          name: "Oppforet tak/loft",
        },
        branncelleOpenOverFlerePlan: {
          isSelected: false,
          name: "Branncelle åpen over flere plan",
        },
        garasje: {
          isSelected: false,
          name: "Garasje",
        },
        brannsluse: {
          isSelected: false,
          name: "Brannsluse",
        },
        romForLagringAvBrensel: {
          isSelected: false,
          name: "Rom for lagring av brensel",
        },
        svalgang: {
          isSelected: false,
          name: "Svalgang (som er rømningsvei)",
        },
      },
    },
    sjakt: {
      title: "Sjakttyper",
      instructions: "Hvilke sjakttyper er det i bygget",
      options: {
        installasjonsSjakt: {
          isSelected: false,
          name: "Installasjonssjakter",
        },
        heisSjakt: {
          isSelected: false,
          name: "Heissjakt",
        },
        ingen: {
          isSelected: false,
          name: "Ingen",
        },
      },
    },
    materialer: {
      title: "Materialer og produkters egenskaper ved brann",
      instructions:
        "Sett kryss for det som gjelder for ditt byggverk. Er det laget egne branntegninger som viser krav til overflater og kledning?",
      options: {
        ja: {
          isSelected: false,
          name: "Ja",
        },
        neiRKL15OgBKL1: {
          isSelected: false,
          name: "Nei, RKL1-5 og BKL1",
        },
        neiRKL15OgBKL23: {
          isSelected: false,
          name: "Nei, RKL1-5 og BKL2/3",
        },
        neiRKL6OgBKL1: {
          isSelected: false,
          name: "Nei, RKL6 og BKL1",
        },
        neiRKL6OgBKL23: {
          isSelected: false,
          name: "Nei, RKL6 og BKL2/3",
        },
        nedforetHimlingIRomningsvei: {
          isSelected: false,
          name: "Nedforet himling i rømningsvei - byggverket skal ha nedforet himling i rømningsvei.",
        },
        brukAvBrennbarIsolasjon: {
          isSelected: false,
          name: "Det tillattes bruk av brennbar isolasjon.",
        },
      },
    },
    ventilasjonsanlegg: {
      title: "Ventilasjonsanlegg",
      instructions: "Sett kryss for det som gjelder for ditt byggverk.",
      options: {
        brannOgEllerRoykspjeld: {
          isSelected: false,
          name: "Brann og/eller røykspjeld",
        },
        boligkjokken: {
          isSelected: false,
          name: "Boligkjøkken",
        },
        storkjokkenFrityranlegg: {
          isSelected: false,
          name: "Storkjøkken, frityranlegg eller lignende",
        },
        brannseksjonering: {
          isSelected: false,
          name: "Bygget er brannseksjonert",
        },
      },
    },
    solcellsanlegg: {
      title: "Solcelleanlegg",
      instructions: "Skal byggverket ha solcelleanlegg?",
      options: {
        ja: {
          isSelected: false,
          name: "Ja",
        },
        nei: {
          isSelected: false,
          name: "Nei",
        },
      },
    },
    romningsOgRedgning: {
      title: "Krav knyttet til rømning og redning",
      instructions: "Sett kryss for hvilke forhold du har i byggverket",
      options: {
        forsamlingslokale: {
          isSelected: false,
          name: "Forsamlingslokale",
        },
        butikklokale: {
          isSelected: false,
          name: "Butikklokale (reoler)",
        },
        alkoholservering: {
          isSelected: false,
          name: "Alkoholservering",
        },
        spesielleTiltak: {
          isSelected: false,
          name: "Spesielle tiltak knyttet til personer med nedsatt funksjonsevne",
        },
      },
    },
    automatiskSlokkeanlegg: {
      title: "Automatisk slokkeanlegg",
      instructions: "Skal byggverket ha automatisk slokkeanlegg?",
      options: {
        nei: {
          isSelected: false,
          name: "Nei",
        },
        sprinkleranleggRKL4: {
          isSelected: false,
          name: "Ja, Automatisk sprinkleranlegg RKL4 NS-EN 16925",
        },
        sprinkleranleggRKL6: {
          isSelected: false,
          name: "Ja, Automatisk sprinkleranlegg RKL6 NS-EN 16925 og NS-EN 1284",
        },
        sprinkleranleggNSEN12845: {
          isSelected: false,
          name: "Ja, Automatisk sprinkleranlegg NS-EN 12845.",
        },
        alternativtSlokkeanlegg: {
          isSelected: false,
          name: "Ja, Automatisk slokkeanlegg (ikke sprinkleranlegg)",
        },
      },
    },
    andreAktiveBrannsikringstiltak: {
      title: "Andre aktive brannsikringstiltak",
      instructions: "Sett kryss for hvilke tiltak som skal gjennomføres i ditt byggverk.",
      options: {
        brannalarmanlegg: {
          isSelected: false,
          name: "Automatisk brannalarmanlegg.",
        },
        uUavBrannalarmanlegg: {
          isSelected: false,
          name: "Universell utforming av automatisk brannalarmanlegg",
        },
        talevarsling: {
          isSelected: false,
          name: "Talevarsling",
        },
        roykvarslere: {
          isSelected: false,
          name: "Røykvarslere (aktuelt for mindre byggverk)",
        },
        ledesystem: {
          isSelected: false,
          name: "Ledesystem",
        },
        roykventilasjonsanlegg: {
          isSelected: false,
          name: "Røykventilasjonsanlegg (utover røykluker trapperom, trykksetting o.l.)",
        },
        andreInstallasjonerForRomningsOgRedningsinnsats: {
          isSelected: false,
          name: "Andre installasjoner for rømnings og redningsinnsats",
        },
      },
    },
    spesielleForholdRomningOgRedning: {
      title: "Spesielle forhold knyttet til rømning og redning",
      instructions: "Sett kryss for det som gjelder for ditt byggverk.",
      options: {
        takterrasse: {
          isSelected: false,
          name: "Takterrasse",
        },
        reservebygg: {
          isSelected: false,
          name: "Reservebygg",
        },
        sengetransport: {
          isSelected: false,
          name: "Sengetransport - redning av pasienter i seng.",
        },
        boligMedEttTrapperomRedning: {
          isSelected: false,
          name: "Bolig med ett trapperom + redning",
        },
        vinduSomRomningsveiRKL4: {
          isSelected: false,
          name: "Vindu som rømningsvei RKL4",
        },
        vinduSomRomningsveiRKL12: {
          isSelected: false,
          name: "Vindu som rømningsvei RKL1, 2",
        },
        vinduSomRomningsveiRKL3: {
          isSelected: false,
          name: "Vindu som rømningsvei RKL3.",
        },
        automatiskeDorerTilRomning: {
          isSelected: false,
          name: "Automatiske dører til rømning",
        },
        evakueringsplan: {
          isSelected: false,
          name: "Krav om evakueringsplan",
        },
        rulleband: {
          isSelected: false,
          name: "Rullebånd til evakuering",
        },
      },
    },
    tilretteleggingForHusdyr: {
      title: "Tilrettelegging for husdyr",
      instructions: "Skal bygget tilrettelegges for husdyr?",
      options: {
        ja: {
          isSelected: false,
          name: "Ja",
        },
        nei: {
          isSelected: false,
          name: "Nei",
        },
      },
    },
    kjelleretasjer: {
      title: "Kjelleretasjer",
      instructions: "Hvor mange kjelleretasjer har byggverket?",
      options: {
        ingen: {
          isSelected: false,
          name: "Ingen",
        },
        kjelleretasje1: {
          isSelected: false,
          name: "1 kjelleretasje",
        },
        flereKjelleretasjer: {
          isSelected: false,
          name: "2 eller flere kjelleretasjer.",
        },
      },
    },
    brannvesen: {
      title: "Brannvesen",
      instructions: "Hva er det lokale brannvesenet til byggverket?",
      options: {
        askerOgBaerum: {
          isSelected: false,
          name: "Asker og Bærum brann og redning",
        },
        bergenBrannvesen: {
          isSelected: false,
          name: "Bergen brannvesen",
        },
        drammen: {
          isSelected: false,
          name: "Drammensregionens Brannvesen IKS",
        },
        follo: {
          isSelected: false,
          name: "Follo Brannvesen IKS",
        },
        gjovik: {
          isSelected: false,
          name: "Gjøvik brannvesen",
        },
        hallingdal: {
          isSelected: false,
          name: "Hallingdal Brann- og Redningstjeneste IKS",
        },
        jevnaker: {
          isSelected: false,
          name: "Jevnaker Brann og Redning",
        },
        lunnerGran: {
          isSelected: false,
          name: "Lunner-Gran brann og redning",
        },
        moss: {
          isSelected: false,
          name: "Mosseregionen interkommunale brann og redning",
        },
        nedreRomerikeBrannvesen: {
          isSelected: false,
          name: "Nedre Romerike brannvesen",
        },
        osloBrannvesen: {
          isSelected: false,
          name: "Oslo brannvesen",
        },
        ringerike: {
          isSelected: false,
          name: "Ringerike Brann- og redningstjeneste",
        },
        rogalandIKS: {
          isSelected: false,
          name: "Rogaland IKS",
        },
        salten: {
          isSelected: false,
          name: "Salten Brann IKS",
        },
        trondheimBrannvesen: {
          isSelected: false,
          name: "Trondheim brannvesen",
        },
        vestfold: {
          isSelected: false,
          name: "Vestfold Interkommunale Brannvesen",
        },
        ovreRomerike: {
          isSelected: false,
          name: "Øvre Romerike brann og redning",
        },
        aalesundBKF: {
          isSelected: false,
          name: "Ålesund BKF",
        },
        andre: {
          isSelected: false,
          name: "Andre brannvesen (Oslo mal)",
        },
      },
    },
    spesiellTilretteleggingForBrannvesen: {
      title: "Spesiell tilrettelegging for brannvesen",
      options: {
        brannmannsheis: {
          isSelected: false,
          name: "Brannmannsheis",
        },
        automatiskGarasjeanlegg: {
          isSelected: false,
          name: "Automatisk garasjeanlegg",
        },
        stigeledningTorropplegg: {
          isSelected: false,
          name: "Stigeledning/tørropplegg",
        },
      },
    },
    tilleggsinformasjon: {
      title: "Tilleggsinformasjon",
      instructions: "Ønsker du å beskrive noen av følgende forutsetninger?",
      options: {
        forutsetningerForByggefasen: {
          isSelected: false,
          name: "Forutsetninger for byggefasen",
        },
        spesielleForholdTilBruksfasen: {
          isSelected: false,
          name: "Spesielle forhold til bruksfasen",
        },
      },
    },
  },
};
